// Added by Sejune Oh on 2019-06-13
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { makeAutoObservable } from 'mobx'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { routerPath } from '@/helper/define'
import Logger from '@/helper/Logger'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import Rootstore from '../../index'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
interface HistoryProps {
    pathName: string
    search: string
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export default class HistoryStore {
    historyQueue: Array<HistoryProps> = []

    root?: Rootstore

    constructor(root: Rootstore) {
        this.root = root
        makeAutoObservable(this)
    }

    dequeueHistory() {
        if (this.historyQueue.length === 0) return null
        const { pathName, search } = this.historyQueue.splice(0, 1)[0]

        if (pathName === `/${routerPath.LOGIN}`) return null

        try {
            const dashboardEnable = this.root!.packageConfig!.checkDashboardEnable()
            const useDashboardAsLanding = this.root!.packageConfig!.checkDashboardIsLanding()
            const rediretionPath =
                dashboardEnable && useDashboardAsLanding ? routerPath.DASHBOARD : routerPath.WORKLIST
            return (pathName === '/' ? rediretionPath : pathName) + search
        } catch (err) {
            Logger.errLog('[HistoryStore] Fail to dequeue history info')
            console.log(err)
            return null
        }
    }

    enqueueHistory({ pathName, search }: HistoryProps) {
        this.historyQueue.push({ pathName, search })
    }

    clearHistory() {
        this.historyQueue = []
    }
}
